import type { Lookup, PriceChangeFilterLookupItem } from "@/graphql/codegen/graphql"

export const mapLookupItemsToDropdownOptions = (
  items?: Lookup[] | PriceChangeFilterLookupItem[]
): { label: string; value: string }[] =>
  (items ?? []).map(({ label, id }) => ({
    label,
    value: id,
  }))
